import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Sidebar.module.css';

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <nav className={styles.mobileNav}>
        <button className={styles.hamburger} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className={styles.mobileTitle}>
          <h1>PDS</h1>
        </div>
      </nav>

      <aside className={`${styles.sidebar} ${isOpen ? styles.open : ''}`}>
        <div className={styles.logo}>
          <h1><Link to="/pds">PDS</Link></h1>
          <p>Plab Design System</p>
        </div>
        <nav className={styles.navigation}>
          <ul>
            <li>
              <h2>기초</h2>
              <ul>
                <li>
                  <Link to="/pds/color">
                    <button>컬러</button>
                  </Link>
                </li>
                <li>
                  <Link to="/pds/typography">
                    <button>타이포그래피</button>
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <h2>컴포넌트</h2>
              <ul>
                <li>
                  <Link to="/pds/button">
                    <button>Button</button>
                  </Link>
                </li>
                <li>
                  <Link to="/pds/input">
                    <button>Input</button>
                  </Link>
                </li>
                <li>
                  <Link to="/pds/select">
                    <button>Select</button>
                  </Link>
                </li>
                <li>
                  <Link to="/pds/radio">
                    <button>Radio</button>
                  </Link>
                </li>
                <li>
                  <Link to="/pds/checkbox">
                    <button>Checkbox</button>
                  </Link>
                </li>
                <li>
                  <Link to="/pds/chip">
                    <button>Chip</button>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </aside>

      {isOpen && (
        <div className={styles.overlay} onClick={toggleMenu}></div>
      )}
    </>
  );
};

export default Sidebar; 